const DUMMY_EMAIL = {
  PREFIX: 'dummysuperviseduser.',
  SUFFIX: '@example.com'
};

const getUsernameFromDummyEmail = (email = '') => {
  const regex = new RegExp(`^${DUMMY_EMAIL.PREFIX}[a-zA-Z0-9]{5}_(.*)${DUMMY_EMAIL.SUFFIX}$`);
  const result = regex.exec(email);

  return result !== null ? result[1] : null;
};

module.exports = {
  DUMMY_EMAIL,
  getUsernameFromDummyEmail
};
